import React from 'react';
import LoginLink from 'core/modules/LoginLink/LoginLink';

import './ForYouSignIn.scss';

function ForYouSignIn({ title }) {
  return (
    <div className="mn_forYouSignIn">
      <h2>{title}</h2>
      <LoginLink className="mn_button">
        Sign in
      </LoginLink>
    </div>
  );
}

export default ForYouSignIn;
